export enum FLOATING_RESOURCE_ADD_MENU_OPTION {
    CLIENT = 'client',
    FARM = 'farm',
    MEMBER = 'member',
    FIELD = 'field',
    ASSET = 'asset',
    APPLICATION = 'application',
    BOUNDARY = 'boundary'
}

export const SELECT_PANEL_PORTAL_ROOT_ID = 'select-panel-portal-root';
